<template>
  <div>
    <div class="row">
      <div class="col-md-12">

        <div v-if="currentCompany.id" class="form-group">
          <span class="company-status-label mr-2">Status da Empresa:</span>
          <CompanyStatusToggle :company="currentCompany" @request-toggle="pendingToggle = $event"/>
        </div>

        <div class="form-group">
          <label for="name_company">Razão Social*</label>
          <input v-model="currentCompany.name" type="text" class="form-control" id="name_company" aria-describedby="emailHelp">
        </div>

        <div class="form-group">
          <label for="cnpj_company">CNPJ*</label>
          <input v-model="currentCompany.cnpj" type="text" class="form-control" id="cnpj_company" v-mask="'XX.XXX.XXX/XXXX-##'">
        </div>

        <div class="form-group">
          <label for="ie_company"  v-tooltip.right="{ content: infoIE(), class: 'tooltip-in-modal'}">
            I.E. <info-icon size="1x"/>
          </label>
          <input v-model="currentCompany.ie" type="text" class="form-control" id="ie_company">
        </div>

        <div class="form-group">
          <label for="company-im">
            I.M. <info-icon size="1x"/>
          </label>
          <input v-model="currentCompany.im" type="text" class="form-control" id="company-im">
        </div>

        <div class="form-group">
          <label>UF*</label>
          <StatesSelect v-model="currentCompany.uf" class="form-control"/>
        </div>

        <div class="form-group">
          <label>Cidade*</label>
          <CitySelect v-model="currentCompany.cityCode" :code-uf="currentCompany.uf" class="form-control"/>
        </div>

        <div class="form-group">
          <label for="company-code">Código</label>
          <input v-model="currentCompany.code" type="text" class="form-control" id="company-code">
        </div>

        <div class="form-group">
          <label for="company-phone">Telefone</label>
          <input v-model="currentCompany.phone" type="text" class="form-control" id="company-phone" v-mask="'(##) #### #####'">
        </div>

        <div class="form-group">
          <label for="company-email">E-mail</label>
          <input v-model="currentCompany.email" type="text" class="form-control" id="company-email">
        </div>

      </div>
    </div>

    <div class="row" v-if="$withPolicy('application', 'companies/insert_or_update')">
      <div class="col-md-12 text-right mb-3">
        <button class="btn btn-outline btn-lg mr-2" @click="cancel">Cancelar</button>
        <button class="btn btn-outline mr-2" @click="showModalCityLogin = true">
          Configurar login e senha
        </button>
        <button class="btn btn-primary btn-lg"
                @click="$emit('saveCompany', currentCompany)"
                :disabled="disabledSaveButton">
          Salvar
        </button>
      </div>
    </div>
  
    <template v-if="currentCompany.id">
      <div class="row" v-if="$withPolicy('application', 'companies/insert_or_update')">
        <hr>
        <div class="col-md-12">
          <CardUser :company="currentCompany"/>
        </div>
  
        <div v-if="getUser.role === 'owner'" class="col-md-12">
          <CardProviders :company="currentCompany"/>
        </div>
      </div>
  
      <ModalCityLogin v-if="showModalCityLogin" v-model="showModalCityLogin" :companyId="currentCompany.id"/>

      <Credentials v-if="currentCompany.id" :company="currentCompany"/>

      <div v-if="currentCompany.id && accountApps.length > 0" class="col-md-12">
        <Services
          :accountApps="accountApps"
          :company="currentCompany"
        />
      </div>
    </template>

    <ModalToggleCompanyStatus
      v-if="pendingToggle"
      :value="true"
      :company="pendingToggle.company"
      :action="pendingToggle.action"
      @input="pendingToggle = null"
      @confirmed="onStatusConfirmed"
    />

  </div>
</template>

<script>
  import Credentials from '@/components/company/CardCredentials'
  import CardProviders from '@/components/company/CardProviders'
  import CardUser from '@/components/company/CardUser'
  import CitySelect from '@/components/shares/specialTag/CitySelect'
  import Services from '@/components/company/container/Services'
  import CompanyStatusToggle from '@/components/company/CompanyStatusToggle'
  import ModalToggleCompanyStatus from '@/components/company/ModalToggleCompanyStatus'

  import EntityProxy from '@/models/EntityProxy'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import GetUser from '@/mixins/GetUser'
  import ModalCityLogin from '@/components/company/ModalCityLogin'
  import { COMPANY_STATUS } from '@/utils/companyStatus'

  import StatesSelect from '../../shares/specialTag/StatesSelect'
  import { InfoIcon } from 'vue-feather-icons'
  import { mask } from 'vue-the-mask'

  export default {
    components: { Credentials, CardProviders, CardUser, CitySelect, CompanyStatusToggle, InfoIcon, ModalCityLogin, ModalToggleCompanyStatus, Services, StatesSelect },
    computed: {
      accountApps() {
        return this.getAccountApps.filter(aa => ['cm-embarcador'].includes(aa.name) && aa.active)
      },
      disabledSaveButton() {
        return !this.currentCompany.uf ||
            !this.currentCompany.name ||
            !this.currentCompany.cnpj
      }
    },
    created() {
      this.currentCompany = EntityProxy.clone(this.company)
    },
    data() {
      return {
        currentCompany: null,
        pendingToggle: null,
        showModalCityLogin: false
      }
    },
    directives: { mask },
    methods: {
      cancel() {
        this.clear()
        this.$emit('cancel')
      },
      clear() {
        this.currentCompany = EntityProxy.clone(this.company)
      },
      infoIE() {
        return 'Caso este campo não seja preenchido, iremos considerar o estabelecimento como isento, ok?'
      },
      onStatusConfirmed() {
        const entityStatusId = this.pendingToggle && this.pendingToggle.action === 'disable'
          ? COMPANY_STATUS.DISABLED
          : COMPANY_STATUS.ENABLED
        this.$set(this.currentCompany, 'entityStatusId', entityStatusId)
        this.pendingToggle = null
        this.$emit('statusUpdated')
      },
    },
    mixins: [GetAccountApps, GetUser],
    name: 'Form',
    props: {
      company: { required: true, type: Object }
    }
  }
</script>

<style scoped>
  .company-status-label {
    font-weight: bold;
    vertical-align: middle;
  }
</style>
